/* eslint-disable no-await-in-loop */
/* eslint-disable operator-linebreak */
/* eslint-disable function-paren-newline */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FormSpy } from 'react-final-form';
import { FormApi, FormState } from 'final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import { CircularProgress } from '@material-ui/core';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { useHistory } from 'react-router-dom';
import routePaths from 'routes/routePaths';
import accountsStore from 'store/accountsStore';
import Form from 'ui/Form/Form';
import Button from 'ui/Button/Button';
import FieldsLeveler from 'ui/structure/FieldsLeveler/FieldsLeveler';
import SubmitLeveler from 'ui/structure/SubmitLeveler/SubmitLeveler';
import { ITransactionField } from 'ui/structure/TransactionCard';
import { OTPConfirmationModal, StatusModal, WarningModal } from 'components/modals';
import { AxiosStatus } from 'api/axiosConfig';
import api from 'api/api';
import { getTransactionsArray } from 'utils/mapping/transactionCardMapper';
import { IApiResponse } from 'utils/models';
import { NETWORK_REQUIRED } from 'utils/constants';
import validateOtpPin, { handlePinError } from 'utils/otpValidation';
import { changeFieldValue, setFieldTouched } from 'utils/formMutators';
import { IOTPError } from 'components/authModules/LogIn/login.model';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import noop from 'utils/noop';
import FieldInputLevel from 'ui/structure/FieldInputLevel/FieldInputLevel';
import {
  IChargeState,
  IElevyResponse,
  IElevyState,
  IFormValues,
  IMobileMoneyActions,
  IMobileMoneyChargeResponse,
  IMobileMoneyResponse,
  INetworksResponse,
  IWalletBenResponse,
  IWalletState,
  Warnings,
  bulkDataConfig,
  bulkSortArray,
} from './ManualEntry.model';
import validate from './validation';
import { getReceipt, lookupBen, getTransactionFee } from './submitApi';
import { renderTransferSourceAccount, renderWalletFields } from './ManualEntryField';

import styles from './ManualEntry.module.css';

import plus from 'assets/icons/plus.svg';
import trash from 'assets/icons/trash.png';

const excludedNetworks = ['Surfline', 'Glo', 'Busy'];

const initialValues = {
  transferData: [
    {
      beneficiaryName: '',
      netWork: '',
      beneficiaryWalletNumber: '',
      walletName: '',
      amount: '',
      eleveyFee: '',
      description: '',
    },
  ],
};
interface IProps {
  accounts: IWalletState['accounts'];
  showMainForm: boolean;
  handleChangeForm: () => void;
}
const ManualEntry = ({ accounts, showMainForm, handleChangeForm }: IProps) => {
  const [isConfirmationOpen, setConfirmationOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [successMsg, setSuccessMsg] = useState<string>('');
  const [submitStatus, setSubmitStatus] = useState<AxiosStatus>(AxiosStatus.DEFAULT);
  const [OTPError, setOTPError] = useState<IOTPError | null>(null);
  const [showLookupPrompt, setShowLookupPrompt] = useState(false);
  const [isFormDirty, setFormDirty] = useState(false);
  const [state, setState] = useState<IWalletState>({ accounts: [], networks: [], beneficiaries: [] });
  const [elevyState, setElevyState] = useState<IElevyState>({
    charge: '',
    taxableAmount: '',
    eLevyId: '',
  });
  const [chargeState, setChargeState] = useState<IChargeState>({
    charge: 0,
  });
  const [elevyResponseList, setElevyResponseList] = useState<IElevyResponse[]>([]);
  const [chargeResponseList, setChargeResponseList] = useState<IMobileMoneyChargeResponse[]>([]);
  const updateState = useCallback((update: Partial<IWalletState>) => setState((prev) => ({ ...prev, ...update })), []);
  const [confirmData, setConfirmData] = useState<ITransactionField[]>([]);
  const [transactionId, setTransactionId] = useState<number>(NaN);
  const submitting = submitStatus === AxiosStatus.PENDING;
  const showStatusModal = submitStatus === AxiosStatus.SUCCESS || submitStatus === AxiosStatus.FAILURE;
  let mainForm!: FormApi<IFormValues, Partial<IFormValues>>;

  const history = useHistory();
  const handleOnSuccess = () => {
    history.push(routePaths.dashboard);
  };

  const onCloseStatusModal = () => {
    if (submitStatus === AxiosStatus.SUCCESS) {
      handleOnSuccess();
    }
    setSubmitStatus(AxiosStatus.DEFAULT);
    setSuccessMsg('');
    setErrorMsg('');
  };

  const onResend = () => api.post('/customer/otp/generate');
  const openConfirmation = () => setConfirmationOpen(true);
  const closeConfirmation = () => {
    if (submitStatus === AxiosStatus.SUCCESS) {
      handleOnSuccess();
    } else {
      setConfirmationOpen(false);
    }
  };

  const closeLookupPrompt = useCallback(() => setShowLookupPrompt(false), []);

  const { ghsAccounts } = accountsStore;

  useEffect(() => updateState({ accounts: toJS(ghsAccounts) }), [ghsAccounts, updateState]);

  useEffect(() => {
    const fetchAccounts = () => {
      if (ghsAccounts.length) {
        // accounts loaded already
        return Promise.resolve();
      }
      return accountsStore.fetchAccounts();
    };

    const fetchNetworks = () =>
      api
        .get('/billspayment/networks', {}, true, false)
        .then((response: INetworksResponse) => {
          updateState({ networks: response.networks.filter(({ name }) => !excludedNetworks.includes(name)) });
        })
        .catch((error) => {
          console.error('error', error);
        });

    Promise.all([fetchNetworks(), fetchAccounts()]).finally(() => {
      setSuccessMsg('');
    });
  }, [updateState]);

  const getPrincipalAmount = (values: IFormValues) => {
    const transferList = values.transferData;
    return transferList.reduce((total, item) => total + Number(item.amount) || 0, 0);
  };

  const getPrincipalCharge = () => {
    if (elevyState) {
      return elevyState.charge;
    }
    return 0;
  };
  const findBeneficiaryName = useCallback(
    async (index: number) => {
      const value = mainForm.getState().values;
      const beneficiaryData = value?.transferData || [];
      const currentBen = beneficiaryData[index];
      const data = currentBen.netWork && currentBen.beneficiaryWalletNumber;
      if (data) {
        try {
          const response: IWalletBenResponse = await lookupBen(
            currentBen.netWork,
            currentBen.beneficiaryWalletNumber,
            'A2W',
          );
          updateState({ walletName: response.accountName });
          mainForm.mutators.changeFieldValue(`transferData[${index}].walletName`, String(response.accountName));
        } catch (error) {
          console.error(error);
        } finally {
          updateState({
            isLookingUp: false,
            lastLookedUpPhone: currentBen.beneficiaryWalletNumber,
            lastLookedUpNetwork: currentBen.netWork,
          });
        }
      }
    },
    [],
  );

  const handleTransactionCharge = useCallback(
    async (index: number) => {
      const value = mainForm.getState().values;
      const beneficiaryData = value?.transferData || [];
      const currentBen = beneficiaryData[index];
      const data = currentBen.netWork && currentBen.amount;
      if (data) {
        try {
          const response: IMobileMoneyChargeResponse = await getTransactionFee(
            currentBen.amount,
            currentBen.netWork,
          );
          setChargeResponseList((prev) => [...prev, response]);
          setChargeState({
            charge: response.charge,
          });
          // return response;
        } catch (err) {
          console.error('transaction charge fee', err);
          throw err;
        } finally {
          updateState({
            isLookingUp: false,
          });
        }
      }
    }, []);
  // const handleTransactionCharge = async () => {
    //   const value = mainForm.getState().values;
    //   const { transferData } = value;
    //   const promises = transferData.map(async (currentTransfer) => {
    //     const datas = currentTransfer.netWork && currentTransfer.amount;
    //     if (datas) {
    //       try {
    //         const response: IMobileMoneyChargeResponse = await getTransactionFee(
    //           currentTransfer.amount,
    //           currentTransfer.netWork,
    //         );
    //         setChargeResponseList((prev) => [...prev, response]);
    //         setChargeState({
    //           charge: response.charge,
    //         });
    //         return response;
    //       } catch (err) {
    //         console.error(err);
    //         throw err;
    //       } finally {
    //         updateState({
    //           isLookingUp: false,
    //         });
    //       }
    //     }

  //     return null;
  //   });

  //   setSubmitStatus(AxiosStatus.PENDING);

  //   try {
  //     await Promise.all(promises);
  //     setSubmitStatus(AxiosStatus.DEFAULT);
  //   } catch (error) {
  //     setSubmitStatus(AxiosStatus.DEFAULT);
  //   }
  // };
  const getPrincipalTransactionCharge = (values: IFormValues) => {
    const transferList = values.transferData;
    if (transferList.length > 0) {
      transferList.forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.charge = chargeState.charge;
      });
      const result = transferList.map((item) => Number(item.charge)).reduce((a, b) => a + b, 0);
      return result;
    }
    return 0;
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleElevyResponse = async (index: number) => {
    const value = mainForm.getState().values;
    const { transferData } = value;

    if (transferData.length > 0) {
      const firstTransfer = transferData[0];
      const gipCodeForResponse = state.networks.find((network) => firstTransfer.netWork === network.code);

      if (gipCodeForResponse) {
        const requestBody = {
          sourceAccount: value.sourceAccount,
          destinationAccount: firstTransfer.beneficiaryWalletNumber,
          destinationGipCode: gipCodeForResponse.gipCode,
          amount: getPrincipalAmount(value),
        };
        try {
          const data: IElevyResponse = await api.post('transfer/eLevyCharge', requestBody);
          setElevyResponseList([data]);
          setElevyState({
            charge: data.charge,
            eLevyId: data.eLevyId,
            taxableAmount: data.taxableAmount,
          });
          await handleTransactionCharge(index);
        } catch (err) {
          console.error(err);
        }
      }
    } else {
      setSubmitStatus(AxiosStatus.FAILURE);
    }
  };
  const actions = useMemo<IMobileMoneyActions>(
    () => ({
      findBeneficiaryName,
      handleElevyResponse,
    }),
    [findBeneficiaryName, handleElevyResponse],
  );
  const onRejectedSubmit = useCallback((error: IApiResponse) => {
    console.error(error || NETWORK_REQUIRED);
    setErrorMsg(error.description || NETWORK_REQUIRED);
    setSubmitStatus(AxiosStatus.FAILURE);
  }, []);

  const onSubmit = (values: IFormValues) => {
    const readyValues = {
      sourceAccount: values.sourceAccount,
      Numberoftransactions: values.transferData.length,
      PrincipalAmount: getPrincipalAmount(values),
      TransactionFee: getPrincipalTransactionCharge(values),
      ELevyFee: getPrincipalCharge(),
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      totalAmount: Number(getPrincipalAmount(values))
      + Number(getPrincipalCharge()) + Number(getPrincipalTransactionCharge(values)),
    } as Record<string, string | number>;
    const sourceAccount = ghsAccounts.find((account) => account.accountNumber === values.sourceAccount);
    if (sourceAccount) {
      const { availableBalance } = sourceAccount;
      if (Number(availableBalance) < Number(readyValues.totalAmount)) {
        setSubmitStatus(AxiosStatus.FAILURE);
        setErrorMsg('Transfer failed.\nInsufficient funds to complete the transaction.');
        return;
      }
    }
    api
      .post('/customer/otp/generate')
      .then((resp: IApiResponse) => {
        setSuccessMsg(resp.description);
      })
      .catch((data) => {
        onRejectedSubmit(data);
      });
    setConfirmData(getTransactionsArray(readyValues, bulkDataConfig, undefined, bulkSortArray));
    setSubmitStatus(AxiosStatus.DEFAULT);
    openConfirmation();
  };

  const onLookupPromptSubmit = useCallback(() => {
    closeLookupPrompt();
    openConfirmation();
  }, [closeLookupPrompt]);

  const onConfirm = useCallback(
    (values: IFormValues) => async (otp: string, saveBeneficiary: boolean) => {
      setErrorMsg('');
      setSuccessMsg('');
      setSubmitStatus(AxiosStatus.PIN_PENDING);
      try {
        await validateOtpPin(otp);
        setSubmitStatus(AxiosStatus.PENDING);
        // using elevyResponseList to get the elevy response for each transfer
        const elevyResponse = elevyResponseList[0];
        // using chargeResponseList to get the charge response for each transfer
        const chargeResponses = chargeResponseList.map((chargeResponse) => ({
          charge: chargeResponse.charge,
        }));
        const data = values.transferData.map((item, index) => ({
          ...item,
          amount: Number(item.amount),
          description: item.description,
          eleveyId: elevyResponse.eLevyId,
          transactionType: 'A2W',
          charge: chargeResponses[index].charge,
        }));
        const requestBody = {
          sourceAccount: values.sourceAccount,
          transferData: JSON.stringify(data),
          password: otp,
          passwordType: 'OTP',
          saveBen: saveBeneficiary,
          totalElevyFee: elevyState.charge,
        };
        api
          .post('transfer/manualMobileMoney', requestBody)
          .then((response: IMobileMoneyResponse) => {
            setSuccessMsg(response.description || 'Transfer Completed Successfully!');
            closeConfirmation();
            setSubmitStatus(AxiosStatus.SUCCESS);
            if (response.transactionId) {
              setTransactionId(response.transactionId);
            }
            setConfirmData([]);
          })
          .catch((error: IApiResponse) => {
            console.error(error);
            setErrorMsg(error.description || 'Transfer failed. Unable to complete the transaction.');
            setSubmitStatus(AxiosStatus.FAILURE);
            closeConfirmation();
          })
          .catch((error: IOTPError) => {
            setOTPError(error);
            handlePinError(setSubmitStatus, setErrorMsg);
          });
      } catch (error) {
        console.error(error);
      }
    },
    [elevyState, chargeState, elevyResponseList],
  );

  const onGetReceipt = useCallback(() => getReceipt(transactionId), [transactionId]);

  const onChangeForm = useCallback(
    ({ dirty }: FormState<IFormValues>) => {
      if (isFormDirty !== dirty) {
        handleChangeForm();
        setFormDirty(dirty);
      }
    },
    [handleChangeForm, isFormDirty],
  );
  const onRetryConfirm = () => setSubmitStatus(AxiosStatus.DEFAULT);

  const handleAddBeneficiaryField = (form) => {
    form.mutators.push('transferData', '');
  };

  const fieldDescription = (
    <div>
      <p className={styles.fieldDescription}>Fill in the form below to create a list of bulk beneficiaries</p>
    </div>
  );
  return (
    <>
      {showMainForm && (
        <DashboardCard className={styles.bulkListCard}>
          <Form
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            mutators={{ changeFieldValue, setFieldTouched, ...arrayMutators }}
            render={({ handleSubmit, form, values, hasValidationErrors }) => {
              mainForm = mainForm || form;
              return (
                <form onSubmit={handleSubmit}>
                  <FieldsLeveler label="Source Account">
                    {renderTransferSourceAccount(accounts, submitting)}
                  </FieldsLeveler>
                  <FieldsLeveler label="Beneficiary List" subTitle={fieldDescription}>
                    {' '}
                  </FieldsLeveler>
                  <FieldArray name="transferData">
                    {({ fields }) => (
                      <>
                        {fields.map((name: string, index: number) => (
                          <div key={name} className={styles.fields}>
                            <div className={styles.fieldsContainer}>
                              <FieldInputLevel>
                                {renderWalletFields(
                                  name,
                                  values,
                                  state,
                                  form,
                                  actions,
                                  index,
                                  submitting,
                                )}
                              </FieldInputLevel>
                            </div>
                            {fields.length && fields.length > 1 ? (
                              <div
                                className={styles.deleteButton}
                                role="button"
                                tabIndex={0}
                                onClick={() => fields.remove(index)}
                                onKeyPress={noop}
                              >
                                <img src={trash} alt="delete icon" width="40" height="40" />
                              </div>
                            ) : null}
                          </div>
                        ))}
                      </>
                    )}
                  </FieldArray>
                  {values.transferData.length === 50 ? (
                    <p>{Warnings.MAX_FIELD_ENTRY}</p>
                  ) : (
                    <div
                      className={styles.addBeneficiaryButton}
                      role="button"
                      tabIndex={0}
                      onKeyPress={noop}
                      onClick={() => handleAddBeneficiaryField(form)}
                    >
                      <img src={plus} alt="delete icon" />
                      <p>Add one more beneficiary</p>
                    </div>
                  )}
                  <SubmitLeveler>
                    <Button type="submit" disabled={submitting || hasValidationErrors} fullWidth>
                      {submitting ? <CircularProgress size={20} color="inherit" /> : 'Make Transfer'}
                    </Button>
                  </SubmitLeveler>
                  <OTPConfirmationModal
                    open={isConfirmationOpen}
                    data={confirmData}
                    onClose={closeConfirmation}
                    OTPPinError={OTPError}
                    onResend={onResend}
                    onSubmit={onConfirm(values)}
                    submitStatus={submitStatus}
                    onSuccess={handleOnSuccess}
                    onRetry={onRetryConfirm}
                    getReceipt={onGetReceipt}
                    successText={successMsg}
                    failureText={errorMsg}
                    askSaveBeneficiary
                    disableSaveBeneficiary={!!state.selectedBeneficiary}
                    defaultSaveBeneficiary={state.selectedBeneficiary ? false : undefined}
                  />
                  <StatusModal
                    open={showStatusModal}
                    status={submitStatus === AxiosStatus.SUCCESS ? 'success' : 'failure'}
                    onClose={onCloseStatusModal}
                    onRetry={onCloseStatusModal}
                    onRetryText="Close"
                  >
                    {submitStatus === AxiosStatus.SUCCESS ? successMsg : errorMsg}
                  </StatusModal>
                  <WarningModal
                    open={showLookupPrompt}
                    submitName="Continue"
                    cancelName="Close"
                    onSubmit={onLookupPromptSubmit}
                    onClose={closeLookupPrompt}
                  >
                    Mobile Money Name has not been validated. Would you like to continue?
                  </WarningModal>
                  <FormSpy subscription={{ dirty: true }} onChange={onChangeForm} />
                </form>
              );
            }}
          />
        </DashboardCard>
      )}
    </>
  );
};

export default observer(ManualEntry);
